export type StateInvalidationDomain = "orders" | "payments" | "marketplace" | "addresses" | "idv" | "bootstrap" | "cart" | "wishlist"

export type StateInvalidationTrigger = "purchase" | "address" | "idv" | "cart" | "wishlist"

const TRIGGER_DOMAINS: Readonly<Record<StateInvalidationTrigger, ReadonlyArray<StateInvalidationDomain>>> = {
  cart: ["cart"],
  wishlist: ["wishlist"],
  purchase: ["orders", "payments", "marketplace"],
  address: ["addresses"],
  idv: ["idv", "bootstrap"],
}

export const invalidationDomainsFor = (trigger: StateInvalidationTrigger): ReadonlyArray<StateInvalidationDomain> => TRIGGER_DOMAINS[trigger]

const LOCAL_QUERY_KEYS: Readonly<Record<StateInvalidationTrigger, ReadonlyArray<string>>> = {
  purchase: ["orders", "userBootstrap"],
  address: ["addresses", "cart"],
  idv: ["cart", "userProfile", "userBootstrap"],
  cart: ["lastCheckoutProductDetails", "cartProductDetails"],
  wishlist: ["wishlist", "wishlistProducts"],
}

export const localInvalidationKeysFor = (trigger: StateInvalidationTrigger): ReadonlyArray<string> => LOCAL_QUERY_KEYS[trigger]
